// src/components/card/CardLabels.js
import React from 'react';
import { POS } from './layout';
import { fonts, kicker, place, placeTL } from './ui';

export default function CardLabels({ px }) {
  const dy = -85;
  const sy =  70;
  const zTop = { zIndex: 2 };

  // 資訊區的行高：密碼 → 個人櫃 → 電話 → 信箱
  const L0 = POS.infoTop;         // 密碼 Password
  const L1 = POS.infoTop + 70;    // 個人櫃 Locker
  const L2 = POS.infoTop + 140;   // 電話 Mobile
  const L3 = POS.infoTop + 210;   // 信箱 Email

  return (
    <>
      {/* 左上角資訊小標 */}
      <div style={{ ...placeTL(px, POS.name.x  - 25, POS.name.y, fonts.label), ...zTop }}>姓名 Name</div>
      <div style={{ ...placeTL(px, POS.level.x - 25, POS.level.y, fonts.label), ...zTop }}>等級 Level</div>

      {/* 三格上方中文小標（置中） */}
      <div style={{ ...place(px, POS.point.x, POS.point.y + dy, fonts.label2), ...zTop }}>點數Point</div>
      <div style={{ ...place(px, POS.pass.x,  POS.pass.y  + dy, fonts.label2), ...zTop }}>日券Day Pass</div>

      {/* 三格下方英文單位（置中） */}
      <div style={{ ...place(px, POS.point.x, POS.point.y + sy, kicker), ...zTop }}>點 Points</div>
      <div style={{ ...place(px, POS.pass.x,  POS.pass.y  + sy, kicker), ...zTop }}>張 Pass</div>

      {/* 其它區段小標（左上錨點）：密碼 → 個人櫃 → 電話 → 信箱 */}
      <div style={{ ...placeTL(px, 150, POS.progressPointY , fonts.labelinfo), ...zTop }}>集點進度</div>
      <div style={{ ...placeTL(px, 150, L0, fonts.labelinfo), ...zTop }}>密碼 Password</div>
      <div style={{ ...placeTL(px, 150, L1, fonts.labelinfo), ...zTop }}>個人櫃 Locker</div>
      <div style={{ ...placeTL(px, 150, L2, fonts.labelinfo), ...zTop }}>電話 Mobile</div>
      <div style={{ ...placeTL(px, 150, L3, fonts.labelinfo), ...zTop }}>信箱 Email</div>
      { /*<div style={{ ...placeTL(px, 150, L3, fonts.labelinfo), ...zTop }}>福利 Benefits</div>*/}
    </>
  );
}
